import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=48896d87&"
import script from "./Dialogs.vue?vue&type=script&lang=js&"
export * from "./Dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports